<template class="main">
  <div class="login">
    <div data-title="欢迎登录｜注册"></div>
    <el-row class="login-row">
      <el-col
        :xl="{ span: 14, offset: 5 }"
        :lg="{ span: 14, offset: 5 }"
        :md="{ span: 22, offset: 1 }"
        :sm="{ span: 22, offset: 1 }"
        :xs="{ span: 22, offset: 1 }"
        class="login-col"
      >
        <el-card class="login-box">
          <el-row>
            <el-col :lg="10" :md="10">
              <div class="left">
                <div class="box-left-top">
                  <div class="login-title">实验语言学</div>
                  <div class="lobin-content">
                    <p>欢迎使用实验语言学投稿系统 ，请登录或注册后继续！</p>
                  </div>
                  <div v-if="showType == 'login'" class="register">
                    <span>还没有账号？</span>
                    <span
                      @click="switchModl"
                      class="link"
                      style="font-weight: 900; color: white; font-size: 18px"
                    >马上注册</span
                    >
                  </div>
                  <div v-if="showType != 'login'" class="register">
                    <span @click="switchModl" class="link"
                    ><i class="fa fa-arrow-left"></i>返回登录</span
                    >
                  </div>
                  <div class="myemail">
                    <p>
                      <i class="fa fa-envelope"></i
                      >联系编辑部：SYlinguistics@163.com
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :lg="14" :md="14">
              <!--登录-->
              <div class="right" v-if="showType == 'login'">
                <div class="login-title">登录账号</div>
                <div class="login-input">
                  <el-form>
                    <el-form-item>
                      <template slot="label">
                        <label> <i class="fa fa-user"></i>&nbsp;邮箱 </label>
                      </template>
                      <el-input
                        type="text"
                        placeholder="邮箱"
                        v-model="loginData.email"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-lock"></i>&nbsp;密码</label>
                      </template>
                      <el-input
                        type="password"
                        placeholder="输入密码"
                        v-model="loginData.password"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="forget">
                  <el-link @click="showType = 'forget'"
                  ><i class="fa fa-unlock"></i>忘记密码？
                  </el-link
                  >
                </div>
                <div class="login-btn">
                  <el-button
                    @click.native="doLogin()"
                    style="width: 100%; background-color: #3e8a73; color: white"
                    size="medium"
                  ><i class="fa fa-sign-in"></i>登录
                  </el-button
                  >
                </div>
              </div>
              <!-- 注册 -->
              <div class="right" v-if="showType == 'register'">
                <div class="login-title">注册账号</div>
                <div class="login-input">
                  <el-form>
                    <el-form-item>
                      <template slot="label">
                        <label> <i class="fa fa-user"></i>&nbsp;真实姓名 </label>
                      </template>
                      <el-input
                        autocomplete="off"
                        type="text"
                        placeholder="用户名"
                        v-model="registerData.name"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label>
                          <i class="fa fa-envelope"></i>&nbsp;邮箱
                        </label>
                      </template>
                      <el-input
                        type="email"
                        placeholder="注册邮箱"
                        v-model="registerData.email"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-lock"></i>&nbsp;密码</label>
                      </template>
                      <el-input
                        autocomplete="off"
                        type="password"
                        placeholder="输入密码"
                        v-model="registerData.password"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label> <i class="fa fa-meetup"></i>&nbsp;单位 </label>
                      </template>
                      <el-input
                        autocomplete="off"
                        type="text"
                        placeholder="所属单位"
                        v-model="registerData.unit"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label> <i class="fa fa-phone"></i>&nbsp;手机号 </label>
                      </template>
                      <el-input
                        type="phone"
                        placeholder="手机号"
                        v-model="registerData.phone"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-flag"></i>&nbsp;国家</label>
                      </template>
                      <el-select
                        el-select
                        placeholder="请选择国家"
                        filterable
                        size="medium"
                        style="width: 100%"
                        v-model="registerData.country"
                      >
                        <el-option-group
                          v-for="group in registerData.countryOptions"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          >
                            <span style="float: left">{{ item.label }}</span>
                            <span
                              style="
                                float: right;
                                color: #8492a6;
                                font-size: 13px;
                              "
                            >{{ item.value }}</span
                            >
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-vcard"></i>&nbsp;注册角色</label>
                      </template>
                      <el-select
                        el-select
                        placeholder="请选择角色"
                        filterable
                        size="medium"
                        style="width: 100%"
                        v-model="registerData.type"
                      >
                        <el-option
                          v-for="item in registerData.registerOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          style="width: 100%"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="login-btn">
                  <el-button
                    @click="doRegister"
                    type="primary"
                    style="
                      width: 100%;
                      border: none;
                      background-color: #3e8a73;
                      color: white;
                    "
                    size="medium"
                  ><i class="fa fa-registered"></i>注册
                  </el-button
                  >
                </div>
              </div>
              <!-- 忘记密码 -->
              <div class="right" v-if="showType == 'forget'">
                <div class="login-title">找回密码</div>
                <div class="login-input">
                  <el-form>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-envelope"></i>注册时姓名</label>
                      </template>
                      <el-input
                        type="name"
                        placeholder="输入注册时姓名"
                        v-model="findBackData.name"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-envelope"></i>注册时邮箱</label>
                      </template>
                      <el-input
                        type="email"
                        placeholder="请输入邮箱"
                        v-model="findBackData.email"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label
                        ><i class="fa fa-envelope"></i
                        >需要修改密码的角色</label
                        >
                      </template>
                      <el-select
                        el-select
                        placeholder="请选择角色"
                        filterable
                        size="medium"
                        style="width: 100%"
                        v-model="findBackData.type"
                      >
                        <el-option
                          v-for="item in findBackData.registerOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          style="width: 100%"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <template slot="label">
                        <label><i class="fa fa-lock"></i>新密码</label>
                      </template>
                      <el-input
                        type="password"
                        placeholder="请输入新密码"
                        v-model="findBackData.password"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="login-btn">
                  <el-button
                    @click="findPassword"
                    type="primary"
                    style="
                      width: 100%;
                      background-color: #3e8a73;
                      color: white;
                      border: none;
                    "
                    size="medium"
                  ><i class="fa fa-fighter-jet"></i>马上找回
                  </el-button
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {login, updatePassword, register} from '@/api/data'
import {setCookie, getCookie, removeCookie} from '@/api/libs/cookie'
import * as formValid from '@/api/libs/formValid'

export default {
  name: 'Login',
  data() {
    return {
      checked: false,
      registerData: {
        name: '',
        password: '',
        unit: '',
        phone: '',
        type: '',
        email: '',
        country: '',
        countryOptions: [
          {
            label: '热门国家',
            options: [{value: 'China', label: '中国'}]
          },
          {
            label: '所有国家',
            options: [
              {value: 'Angola', label: '安哥拉'},
              {value: 'Afghanistan', label: '阿富汗'},
              {value: 'Albania', label: '阿尔巴尼亚'},
              {value: 'Algeria', label: '阿尔及利亚'},
              {value: 'Andorra', label: '安道尔共和国'},
              {value: 'Anguilla', label: '安圭拉岛'},
              {value: 'Antigua and Barbuda', label: '安提瓜和巴布达'},
              {value: 'Argentina', label: '阿根廷'},
              {value: 'Armenia', label: '亚美尼亚'},
              {value: 'Ascension', label: '阿森松'},
              {value: 'Australia', label: '澳大利亚'},
              {value: 'Austria', label: '奥地利'},
              {value: 'Azerbaijan', label: '阿塞拜疆'},
              {value: 'Bahamas', label: '巴哈马'},
              {value: 'Bahrain', label: '巴林'},
              {value: 'Bangladesh', label: '孟加拉国'},
              {value: 'Barbados', label: '巴巴多斯'},
              {value: 'Belarus', label: '白俄罗斯'},
              {value: 'Belgium', label: '比利时'},
              {value: 'Belize', label: '伯利兹'},
              {value: 'Benin', label: '贝宁'},
              {value: 'Bermuda Is', label: '百慕大群岛'},
              {value: 'Bolivia', label: '玻利维亚'},
              {value: 'Botswana', label: '博茨瓦纳'},
              {value: 'Brazil', label: '巴西'},
              {value: 'Brunei', label: '文莱'},
              {value: 'Bulgaria', label: '保加利亚'},
              {value: 'Burkina Faso', label: '布基纳法索'},
              {value: 'Burma', label: '缅甸'},
              {value: 'Burundi', label: '布隆迪'},
              {value: 'Cameroon', label: '喀麦隆'},
              {value: 'Canada', label: '加拿大'},
              {value: 'Cayman Is', label: '开曼群岛'},
              {value: 'Central African Republic', label: '中非共和国'},
              {value: 'Chad', label: '乍得'},
              {value: 'Chile', label: '智利'},
              {value: 'China', label: '中国'},
              {value: 'Colombia', label: '哥伦比亚'},
              {value: 'Congo', label: '刚果'},
              {value: 'Cook Is', label: '库克群岛'},
              {value: 'Costa Rica', label: '哥斯达黎加'},
              {value: 'Cuba', label: '古巴'},
              {value: 'Cyprus', label: '塞浦路斯'},
              {value: 'Czech Republic', label: '捷克'},
              {value: 'Denmark', label: '丹麦'},
              {value: 'Djibouti', label: '吉布提'},
              {value: 'Dominica Rep', label: '多米尼加共和国'},
              {value: 'Ecuador', label: '厄瓜多尔'},
              {value: 'Egypt', label: '埃及'},
              {value: 'EI Salvador', label: '萨尔瓦多'},
              {value: 'Estonia', label: '爱沙尼亚'},
              {value: 'Ethiopia', label: '埃塞俄比亚'},
              {value: 'Fiji', label: '斐济'},
              {value: 'Finland', label: '芬兰'},
              {value: 'France', label: '法国'},
              {value: 'French Guiana', label: '法属圭亚那'},
              {value: 'French Polynesia', label: '法属玻利尼西亚'},
              {value: 'Gabon', label: '加蓬'},
              {value: 'Gambia', label: '冈比亚'},
              {value: 'Georgia', label: '格鲁吉亚'},
              {value: 'Germany', label: '德国'},
              {value: 'Ghana', label: '加纳'},
              {value: 'Gibraltar', label: '直布罗陀'},
              {value: 'Greece', label: '希腊'},
              {value: 'Grenada', label: '格林纳达'},
              {value: 'Guam', label: '关岛'},
              {value: 'Guatemala', label: '危地马拉'},
              {value: 'Guinea', label: '几内亚'},
              {value: 'Guyana', label: '圭亚那'},
              {value: 'Haiti', label: '海地'},
              {value: 'Honduras', label: '洪都拉斯'},
              {value: 'Hungary', label: '匈牙利'},
              {value: 'Iceland', label: '冰岛'},
              {value: 'India', label: '印度'},
              {value: 'Indonesia', label: '印度尼西亚'},
              {value: 'Iran', label: '伊朗'},
              {value: 'Iraq', label: '伊拉克'},
              {value: 'Ireland', label: '爱尔兰'},
              {value: 'Israel', label: '以色列'},
              {value: 'Italy', label: '意大利'},
              {value: 'Ivory Coast', label: '科特迪瓦'},
              {value: 'Jamaica', label: '牙买加'},
              {value: 'Japan', label: '日本'},
              {value: 'Jordan', label: '约旦'},
              {value: 'Kampuchea (Cambodia )', label: '柬埔寨'},
              {value: 'Kazakstan', label: '哈萨克斯坦'},
              {value: 'Kenya', label: '肯尼亚'},
              {value: 'Korea', label: '韩国'},
              {value: 'Kuwait', label: '科威特'},
              {value: 'Kyrgyzstan', label: '吉尔吉斯坦'},
              {value: 'Laos', label: '老挝'},
              {value: 'Latvia', label: '拉脱维亚'},
              {value: 'Lebanon', label: '黎巴嫩'},
              {value: 'Lesotho', label: '莱索托'},
              {value: 'Liberia', label: '利比里亚'},
              {value: 'Libya', label: '利比亚'},
              {value: 'Liechtenstein', label: '列支敦士登'},
              {value: 'Lithuania', label: '立陶宛'},
              {value: 'Luxembourg', label: '卢森堡'},
              {value: 'Madagascar', label: '马达加斯加'},
              {value: 'Malawi', label: '马拉维'},
              {value: 'Malaysia', label: '马来西亚'},
              {value: 'Maldives', label: '马尔代夫'},
              {value: 'Mali', label: '马里'},
              {value: 'Malta', label: '马耳他'},
              {value: 'Mariana Is', label: '马里亚那群岛'},
              {value: 'Martinique', label: '马提尼克'},
              {value: 'Mauritius', label: '毛里求斯'},
              {value: 'Mexico', label: '墨西哥'},
              {value: 'Moldova', label: '摩尔多瓦'},
              {value: 'Monaco', label: '摩纳哥'},
              {value: 'Mongolia', label: '蒙古'},
              {value: 'Montserrat Is', label: '蒙特塞拉特岛'},
              {value: 'Morocco', label: '摩洛哥'},
              {value: 'Mozambique', label: '莫桑比克'},
              {value: 'Namibia', label: '纳米比亚'},
              {value: 'Nauru', label: '瑙鲁'},
              {value: 'Nepal', label: '尼泊尔'},
              {value: 'Netheriands Antilles', label: '荷属安的列斯'},
              {value: 'Netherlands', label: '荷兰'},
              {value: 'New Zealand', label: '新西兰'},
              {value: 'Nicaragua', label: '尼加拉瓜'},
              {value: 'Niger', label: '尼日尔'},
              {value: 'Nigeria', label: '尼日利亚'},
              {value: 'North Korea', label: '朝鲜'},
              {value: 'Norway', label: '挪威'},
              {value: 'Oman', label: '阿曼'},
              {value: 'Pakistan', label: '巴基斯坦'},
              {value: 'Panama', label: '巴拿马'},
              {value: 'Papua New Cuinea', label: '巴布亚新几内亚'},
              {value: 'Paraguay', label: '巴拉圭'},
              {value: 'Peru', label: '秘鲁'},
              {value: 'Philippines', label: '菲律宾'},
              {value: 'Poland', label: '波兰'},
              {value: 'Portugal', label: '葡萄牙'},
              {value: 'Puerto Rico', label: '波多黎各'},
              {value: 'Qatar', label: '卡塔尔'},
              {value: 'Reunion', label: '留尼旺'},
              {value: 'Romania', label: '罗马尼亚'},
              {value: 'Russia', label: '俄罗斯'},
              {value: 'Saint Lueia', label: '圣卢西亚'},
              {value: 'Saint Vincent', label: '圣文森特岛'},
              {value: 'Samoa Eastern', label: '东萨摩亚(美)'},
              {value: 'Samoa Western', label: '西萨摩亚'},
              {value: 'San Marino', label: '圣马力诺'},
              {value: 'Sao Tome and Principe', label: '圣多美和普林西比'},
              {value: 'Saudi Arabia', label: '沙特阿拉伯'},
              {value: 'Senegal', label: '塞内加尔'},
              {value: 'Seychelles', label: '塞舌尔'},
              {value: 'Sierra Leone', label: '塞拉利昂'},
              {value: 'Singapore', label: '新加坡'},
              {value: 'Slovakia', label: '斯洛伐克'},
              {value: 'Slovenia', label: '斯洛文尼亚'},
              {value: 'Solomon Is', label: '所罗门群岛'},
              {value: 'Somali', label: '索马里'},
              {value: 'South Africa', label: '南非'},
              {value: 'Spain', label: '西班牙'},
              {value: 'SriLanka', label: '斯里兰卡'},
              {value: 'St.Lucia', label: '圣卢西亚'},
              {value: 'St.Vincent', label: '圣文森特'},
              {value: 'Sudan', label: '苏丹'},
              {value: 'Suriname', label: '苏里南'},
              {value: 'Swaziland', label: '斯威士兰'},
              {value: 'Sweden', label: '瑞典'},
              {value: 'Switzerland', label: '瑞士'},
              {value: 'Syria', label: '叙利亚'},
              {value: 'Tajikstan', label: '塔吉克斯坦'},
              {value: 'Tanzania', label: '坦桑尼亚'},
              {value: 'Thailand', label: '泰国'},
              {value: 'Togo', label: '多哥'},
              {value: 'Tonga', label: '汤加'},
              {value: 'Trinidad and Tobago', label: '特立尼达和多巴哥'},
              {value: 'Tunisia', label: '突尼斯'},
              {value: 'Turkey', label: '土耳其'},
              {value: 'Turkmenistan', label: '土库曼斯坦'},
              {value: 'Uganda', label: '乌干达'},
              {value: 'Ukraine', label: '乌克兰'},
              {value: 'United Arab Emirates', label: '阿拉伯联合酋长国'},
              {value: 'United Kiongdom', label: '英国'},
              {value: 'United States of America', label: '美国'},
              {value: 'Uruguay', label: '乌拉圭'},
              {value: 'Uzbekistan', label: '乌兹别克斯坦'},
              {value: 'Venezuela', label: '委内瑞拉'},
              {value: 'Vietnam', label: '越南'},
              {value: 'Yemen', label: '也门'},
              {value: 'Yugoslavia', label: '南斯拉夫'},
              {value: 'Zimbabwe', label: '津巴布韦'},
              {value: 'Zaire', label: '扎伊尔'},
              {value: 'Zambia', label: '赞比亚'}
            ]
          }
        ],
        registerOptions: [
          {value: '投稿人', label: '投稿人'},
          {value: '审稿人', label: '审稿人'}
        ]
      },

      loginData: {
        email: null,
        password: null,
        type: null
      },
      findBackData: {
        email: null,
        name: null,
        type: null,
        password: null,
        registerOptions: [
          {value: '投稿人', label: '投稿人'},
          {value: '审稿人', label: '审稿人'}
        ]
      },

      showType: 'login'
    }
  },
  methods: {
    switchModl() {
      this.clearWarning()
      this.showType = this.showType == 'login' ? 'register' : 'login'
    },
    formValid(type) {
      let validResult = {}
      if (type == 'login') {
        validResult = formValid.checkLogin(
          this.loginData.email,
          this.loginData.password
        )
      }
      if (type == 'register') {
        validResult = formValid.checkRegister(this.registerData)
      }
      if (type == 'findPassword') {
        validResult = formValid.checkFindPassword(
          this.findBackData.email,
          this.findBackData.name,
          this.findBackData.type,
          this.findBackData.password
        )
      }
      // if (!validResult.status) {
      //   this.warningType = validResult.type;
      //   this.warningMesg = validResult.message;
      // }
      return validResult
    },
    findPassword() {
      let validResult = this.formValid('findPassword')
      console.log(validResult.status)
      if (validResult.status) {
        updatePassword(this.findBackData).then((res) => {
          if (res.data.result == true) {
            this.$message({
              type: res.status ? 'success' : 'error',
              message: '密码修改成功！'
            })
          } else {
            this.$message({
              type: res.status ? 'success' : 'error',
              message: '密码修改失败！'
            })
          }
        })
      }
    },
    clearWarning() {
      this.warningType = ''
      this.warningMesg = ''
    },
    doLogin() {
      if (this.loginData.type == '责任编辑') {
        login(this.loginData).then((res) => {
          console.log('这' + res)
          if (res.data.result.msg == '登录成功') {
            this.$router.push({
              name: 'index',
              query: {roleFlag: '责任编辑'}
            })
            this.$message({
              type: 'success',
              message: '登录成功'
            })
            setCookie(
              'authority',
              res.data.result.authority,
              res.data.result.timeout
            )
            setCookie(
              'userInfo',
              res.data.result.userInfo,
              res.data.result.timeout
            )
          } else {
            this.$message({
              type: 'error',
              message: '用户名或密码错误'
            })
          }
        })
      }
      if (this.loginData.type == '投稿人') {
        login(this.loginData).then((res) => {
          console.log('这' + res.data)
          if (res.data.result.msg == '登录成功') {
            this.$router.push({
              name: 'index',
              query: {roleFlag: '投稿人'}
            })
            this.$message({
              type: 'success',
              message: '登录成功'
            })
            setCookie(
              'authority',
              res.data.result.authority,
              res.data.result.timeout
            )
            setCookie(
              'userInfo',
              res.data.result.userInfo,
              res.data.result.timeout
            )
          } else {
            this.$message({
              type: 'error',
              message: '用户名或密码错误'
            })
          }
        })
      }
      if (this.loginData.type == '审稿人') {
        login(this.loginData).then((res) => {
          if (res.data.result.msg == '登录成功') {
            this.$router.push({
              name: 'index',
              query: {roleFlag: '审稿人'}
            })
            this.$message({
              type: 'success',
              message: '登录成功'
            })
            setCookie(
              'authority',
              res.data.result.authority,
              res.data.result.timeout
            )
            setCookie(
              'userInfo',
              res.data.result.userInfo,
              res.data.result.timeout
            )
          } else {
            this.$message({
              type: 'error',
              message: '用户名或密码错误'
            })
          }
        })
      }
    },
    getUserInfo() {
    },
    doRegister() {
      if (!Object.values(this.registerData).every(value => value !== '')) {
        this.$message({
          type: 'error',
          message: '请填写完整信息'
        })
        return false
      }
      const phoneRegex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!phoneRegex.test(this.registerData.phone)) {
        this.$message({
          type: 'error',
          message: '手机号信息有误'
        })
        return false
      }
      if (!emailRegex.test(this.registerData.email)) {
        this.$message({
          type: 'error',
          message: '邮箱信息有误'
        })
        return false
      }
      register(this.registerData).then((res) => {
        if (res.data.result == true) {
          this.$message({
            type: 'success',
            message: '注册成功'
          })
          this.switchModl()
        } else {
          this.$message({
            type: 'error',
            message: '注册失败'
          })
        }
      })
    }
  },
  mounted() {
    this.loginData.type = this.$route.query.roleFlag
  }
}
</script>

<style lang="scss" scoped>
$subcolor: rgba(
  $color: #ffffff,
  $alpha: 0.7,
);
$fontColor: var(--fontColor, #344050);
$cardLeftFontColor: var(--cardLeftFontColor, #f9fafd);
$backgroundColor: var(--backgroundColor, #edf2f9);
$cardLeftColor: var(--cardLeftColor, #3385f3);
$cardRightColor: var(--cardRightColor, #ffffff);
$inputBorderColor: var(--inputBorderColor, #d8e2ef);
$labelColor: var(--labelColor, #5e6e82);

.main {
  padding: 0 !important;
  margin: 0 !important;
}

.login {
  height: 100%;

  background-image: url(../../static/materials/dalishi.png);

  .login-row {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }

  .login-box {
    background: linear-gradient(45deg, #34495e, #41b883);

    .left {
      .box-left-top {
        .login-title {
          padding-top: 2rem;
          color: $cardLeftFontColor;
          font-size: 26px;
          font-weight: bold;
          text-shadow: 1px 2px 3px #34495e;
        }

        .lobin-content {
          color: $subcolor;
          padding-top: 2rem;
          margin-bottom: 4rem;
          padding-left: 5px;
          padding-right: 5px;
        }

        .register {
          color: $subcolor;
          margin-bottom: 3rem;

          .link {
            cursor: pointer;
            color: $subcolor;
          }

          .link:hover {
            color: rgba($color: #ffffff, $alpha: 0.8);
          }
        }

        .myemail {
          color: $cardLeftFontColor;
          font-weight: bold;
          margin-top: 2rem;
        }
      }
    }

    .right {
      width: 100%;
      height: 100%;
      background-color: $cardRightColor;

      .login-title {
        text-align: left;
        font-size: 26px;
        font-weight: bold;
        padding: 2rem 1rem 1rem 1rem;
        width: 100%;
      }

      .login-input {
        padding: 0 1rem;
      }

      .login-btn {
        padding: 2rem 1rem;
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  background-color: #d8e2ef;
  width: 100%;
  padding-bottom: 1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue